import React, { useState, useEffect } from "react";
import request from "../../../Helpers/API";
import ProgressBar from "@ramonak/react-progress-bar";
import { DashInforObjetivoVendedor } from "./DashInforObjetivoVendedor";
import { GetMonthNameByNumber } from "../../Administracion/Helper/GetMonthNameByNumber";

import { useHistory } from "react-router-dom";
import LinearProgress from '@mui/material/LinearProgress';
import { LoaderScreen } from "../../components/LoaderScreen";
import { useSelector } from "react-redux";

export const DashScoreCardVendedor = () => {
  const [data, setData] = useState([]);
  const [score, setScore] = useState([]);
  const history = useHistory();
  const { empleado } = useSelector((store) => store.usuario);
  const getMonth = () => {
    const date = new Date();
    return date.getMonth() + 1;
  };
  var mes_actual = getMonth();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CargaScorecardporVendedorDash/MostrarScorecardVendedor`)
      .then((result) => {
        setScore(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  }, []);

  const formatPorcentaje = (real, objetivo) => {
    if (objetivo === 0 && real === 0) {
      return null;
    }

    if (objetivo === 0) {
      return 100;
    }

    const porcentaje = (real / objetivo) * 100;

    return Math.min(porcentaje, 100);
  };

  const getBarColor = (porcentaje) => {
    if (porcentaje <= 60) {
      return "#f44336";
    } else if (porcentaje > 60 && porcentaje < 80) {
      return "#ffc107";
    } else {
      return "#035917";
    }
  };

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 


  return (
    <div className="dash-tabla-score-card-vendedor" onClick={() => history.push("/Ventas/DashboardScorecardVendedor")}>
      <LoaderScreen loader={loader} />
      <div className="header-scordcard-vendedor">Scorecard de {empleado}</div>
      <table cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>
            </th>
            <th colSpan={3}>
              <div>{GetMonthNameByNumber(mes_actual)}</div>
            </th>
          </tr>
          <tr>
            <th>
              <div>Línea</div>
            </th>
            <th>
              <div>Objetivo</div>
            </th>
            <th>
              <div>Real</div>
            </th>
            <th>
              <div>Alcance</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {score.map((score) => {
            const porcentaje = formatPorcentaje(score.unidades_vendidas, score.objetivo);
            if (porcentaje === null) {
              return null;
            }
            const barColor = getBarColor(porcentaje);

            return (
              <tr key={score.idlinea}>
                <td>{capitalizeWords(score.linea)}</td>
                <td>{score.objetivo}</td>
                <td>{score.unidades_vendidas}</td>
                <td>
                  <span className="percentaje">{`${porcentaje.toFixed(0)}%`}</span>
                  <LinearProgress
                    variant="determinate"
                    value={porcentaje}
                    // className="custom-linear-progress"
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      backgroundColor: "#e0e0e0",
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: barColor
                      }
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
